module.exports = __webpack_public_path__ + "static/doctor-cutout-018673be512799b5b1ee159b9e8a008c.png";